import React from "react";
import { useDispatch,useSelector } from "react-redux";
import sharedGlobals from "../sharedglobals";
import * as userActions from '../modules/userprofile/actions/userprofileactions'


function NavBar() {
  const dispatch = useDispatch();
  const userSession = useSelector(state => state.securityReducer.userSession);
  const gotoHome = () => {
    window.location.href=sharedGlobals.appUrls.ssoUrl+'dashboard'
  }
  const signout = () => {
    dispatch(userActions.signOutUser());
  }
  return (
    <div className="navbar-custom topnav-navbar topnav-navbar-dark">
      <div className="container-fluid">
        <a href="/" className="topnav-logo">
          <span className="topnav-logo-lg">
            <img
              src="content/theme/assets/images/asniclogo.png"
              alt=""
              style={{ height: "16" }}
            />
          </span>
          <span className="topnav-logo-sm">
            <img
              src="content/theme/assets/images/asniclogo.png"
              alt=""
              style={{ height: "16" }}
            />
          </span>
        </a>
        <ul className="list-unstyled topbar-menu float-end mb-0">
          
          <li class="dropdown notification-list d-none d-sm-inline-block">
            <a
              class="nav-link dropdown-toggle arrow-none"
              data-bs-toggle="dropdown"
              href="#"
              onClick={()=> gotoHome()}
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <i class="dripicons-home noti-icon"></i>
            </a>
          </li>

          <li className="dropdown notification-list">
            <a
              className="nav-link dropdown-toggle arrow-none"
              data-bs-toggle="dropdown"
              href="#"
              id="topbar-notifydrop"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="dripicons-bell noti-icon"></i>
              <span className="noti-icon-badge"></span>
            </a>
            <div
              className="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg"
              aria-labelledby="topbar-notifydrop"
            >
              <div className="dropdown-item noti-title px-3">
                <h5 className="m-0">
                  <span className="float-end">
                    <a href="javascript: void(0);" className="text-dark">
                      <small>Clear All</small>
                    </a>
                  </span>
                  Notification
                </h5>
              </div>

              <div
                className="px-3"
                style={{ "max-height": "300px" }}
                data-simplebar
              >
                <h5 className="text-muted font-13 fw-normal mt-0">Today</h5>
                <a
                  href="javascript:void(0);"
                  className="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2"
                >
                  <div className="card-body">
                    <span className="float-end noti-close-btn text-muted">
                      <i className="mdi mdi-close"></i>
                    </span>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="notify-icon bg-primary">
                          <i className="mdi mdi-comment-account-outline"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1 text-truncate ms-2">
                        <h5 className="noti-item-title fw-semibold font-14">
                          Datacorp{" "}
                          <small className="fw-normal text-muted ms-1">
                            1 min ago
                          </small>
                        </h5>
                        <small className="noti-item-subtitle text-muted">
                          Caleb Flakelar commented on Admin
                        </small>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="javascript:void(0);"
                  className="dropdown-item p-0 notify-item card read-noti shadow-none mb-2"
                >
                  <div className="card-body">
                    <span className="float-end noti-close-btn text-muted">
                      <i className="mdi mdi-close"></i>
                    </span>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="notify-icon bg-info">
                          <i className="mdi mdi-account-plus"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1 text-truncate ms-2">
                        <h5 className="noti-item-title fw-semibold font-14">
                          Admin{" "}
                          <small className="fw-normal text-muted ms-1">
                            1 hours ago
                          </small>
                        </h5>
                        <small className="noti-item-subtitle text-muted">
                          New user registered
                        </small>
                      </div>
                    </div>
                  </div>
                </a>

                <h5 className="text-muted font-13 fw-normal mt-0">Yesterday</h5>

                <a
                  href="javascript:void(0);"
                  class="dropdown-item p-0 notify-item card read-noti shadow-none mb-2"
                >
                  <div className="card-body">
                    <span className="float-end noti-close-btn text-muted">
                      <i className="mdi mdi-close"></i>
                    </span>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="notify-icon">
                          <img
                            src="assets/images/users/avatar-2.jpg"
                            className="img-fluid rounded-circle"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1 text-truncate ms-2">
                        <h5 className="noti-item-title fw-semibold font-14">
                          Cristina Pride{" "}
                          <small className="fw-normal text-muted ms-1">
                            1 day ago
                          </small>
                        </h5>
                        <small className="noti-item-subtitle text-muted">
                          Hi, How are you? What about our next meeting
                        </small>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="javascript:void(0);"
                  class="dropdown-item p-0 notify-item card read-noti shadow-none mb-2"
                >
                  <div className="card-body">
                    <span className="float-end noti-close-btn text-muted">
                      <i className="mdi mdi-close"></i>
                    </span>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <div className="notify-icon">
                          <img
                            src="assets/images/users/avatar-4.jpg"
                            className="img-fluid rounded-circle"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1 text-truncate ms-2">
                        <h5 className="noti-item-title fw-semibold font-14">
                          Karen Robinson
                        </h5>
                        <small className="noti-item-subtitle text-muted">
                          Wow ! this admin looks good and awesome design
                        </small>
                      </div>
                    </div>
                  </div>
                </a>

                <div className="text-center">
                  <i className="mdi mdi-dots-circle mdi-spin text-muted h3 mt-0"></i>
                </div>
              </div>
            </div>
          </li>
          <li className="dropdown notification-list">
            <a
              className="nav-link dropdown-toggle nav-user arrow-none me-0"
              data-bs-toggle="dropdown"
              id="topbar-userdrop"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="account-user-avatar">
                <img
                  src="content/theme/assets/images/avatar1.png"
                  alt="user-image"
                  className="rounded-circle"
                />
              </span>
              <span>
                <span className="account-user-name">{userSession&&userSession.displayName}</span>
                <span className="account-position"></span>
              </span>
            </a>
            <div
              className="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
              aria-labelledby="topbar-userdrop"
            >
              <div className=" dropdown-header noti-title">
                <h6 className="text-overflow m-0">Welcome !</h6>
              </div>
              <a
                href='/'
                className="dropdown-item notify-item"
              >
                <i className="mdi mdi-chart-areaspline"> </i>
                <span> Dashboard</span>
              </a>
              <a href="/userprofile" class="dropdown-item notify-item" >
                <i className="mdi mdi-account-edit me-1"></i>
                <span>Settings</span>
              </a>

              <a
                href="javascript:void(0);"
                className="dropdown-item notify-item" onClick={()=> signout()}
              >
                <i className="mdi mdi-logout me-1" ></i>
                <span >Logout</span>
              </a>
            </div>
          </li>
        </ul>
        <a className="button-menu-mobile disable-btn">
          <div class="lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </a>
      </div>
    </div>
  );
}

export default NavBar;
